import axios from "axios";
import Cookies from "js-cookie";

const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL;

const client = axios.create({ baseURL: `${ACCOUNTS_URL}/admin-access` });

client.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${Cookies.get("Token")}`;
  return config;
});

// The backend returns either { status: "error", error: { message } } with HTTP 200, or a Nest error body.
const unwrap = async (request) => {
  try {
    const res = await request;
    if (res.data?.status === "error") throw new Error(res.data.error?.message || "Request failed");
    return res.data.data;
  } catch (error) {
    const body = error.response?.data;
    const message = body?.error?.message || (Array.isArray(body?.message) ? body.message.join(", ") : body?.message);
    throw new Error(message || error.message || "Request failed");
  }
};

export const adminApi = {
  me: () => unwrap(client.get("/me")),
  modules: () => unwrap(client.get("/modules")),
  overview: () => unwrap(client.get("/overview")),
  roles: () => unwrap(client.get("/roles")),
  roleOptions: () => unwrap(client.get("/role-options")),
  createRole: (body) => unwrap(client.post("/roles", body)),
  updateRole: (id, body) => unwrap(client.patch(`/roles/${id}`, body)),
  deleteRole: (id) => unwrap(client.delete(`/roles/${id}`)),
  members: () => unwrap(client.get("/members")),
  createMember: (body) => unwrap(client.post("/members", body)),
  updateMember: (id, body) => unwrap(client.patch(`/members/${id}`, body)),
  removeMember: (id) => unwrap(client.delete(`/members/${id}`)),
};
